import React from 'react';
import { useTheme } from 'styled-components';

import { ItemPainel, LegendaContainer, Marcador } from './styles';

// Obrigatória com 2+ séries: a identidade nunca fica só na cor. Uma série só não leva legenda.
export default function Legenda({ nomes }: { nomes: string[] }) {
  const theme = useTheme();
  if (nomes.length < 2) return null;

  return (
    <LegendaContainer>
      {nomes.map((nome, i) => (
        <ItemPainel key={nome}>
          <Marcador $cor={theme.cores.serie[i]} />
          {nome}
        </ItemPainel>
      ))}
    </LegendaContainer>
  );
}
